import { render, staticRenderFns } from "./Correspondances.vue?vue&type=template&id=f53776de"
import script from "./Correspondances.vue?vue&type=script&lang=js"
export * from "./Correspondances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports